// File: /src/components/ProjectsTable.js

import React from 'react';
import '../styles/ProjectsTable.css';

const ProjectsTable = ({
	projects,
	handleSort,
	sortConfig,
	startEditing,
	deleteProject,
	onSelectProject,
	selectedProjects,
}) => {
	// Função para lidar com a seleção/deseleção de todos os projetos
	const handleSelectAll = (isChecked) => {
		if (isChecked) {
			projects.forEach((project) => {
				if (!selectedProjects.includes(project.id)) {
					onSelectProject(project.id);
				}
			});
		} else {
			projects.forEach((project) => {
				if (selectedProjects.includes(project.id)) {
					onSelectProject(project.id);
				}
			});
		}
	};

	return (
		<div className="table-container">
			<table>
				<thead>
					<tr>
						<th>
							<input
								type="checkbox"
								onChange={(e) =>
									handleSelectAll(e.target.checked)
								}
								checked={
									projects.length > 0 &&
									projects.every((project) =>
										selectedProjects.includes(project.id)
									)
								}
							/>
						</th>
						<th onClick={() => handleSort('id')}>
							ID do Projeto{' '}
							{sortConfig.key === 'id' &&
								(sortConfig.direction === 'asc' ? '▲' : '▼')}
						</th>
						<th onClick={() => handleSort('clientId')}>
							ID do Cliente{' '}
							{sortConfig.key === 'clientId' &&
								(sortConfig.direction === 'asc' ? '▲' : '▼')}
						</th>
						<th onClick={() => handleSort('name')}>
							Nome do Projeto{' '}
							{sortConfig.key === 'name' &&
								(sortConfig.direction === 'asc' ? '▲' : '▼')}
						</th>
						<th onClick={() => handleSort('clientName')}>
							Cliente{' '}
							{sortConfig.key === 'clientName' &&
								(sortConfig.direction === 'asc' ? '▲' : '▼')}
						</th>
						<th>Descrição</th>
						<th onClick={() => handleSort('value')}>
							Valor{' '}
							{sortConfig.key === 'value' &&
								(sortConfig.direction === 'asc' ? '▲' : '▼')}
						</th>
						<th onClick={() => handleSort('due_date')}>
							Data de Vencimento{' '}
							{sortConfig.key === 'due_date' &&
								(sortConfig.direction === 'asc' ? '▲' : '▼')}
						</th>
						<th onClick={() => handleSort('status')}>
							Status{' '}
							{sortConfig.key === 'status' &&
								(sortConfig.direction === 'asc' ? '▲' : '▼')}
						</th>
						<th>Ações</th>
					</tr>
				</thead>
				<tbody>
					{projects.length > 0 ? (
						projects.map((project) => (
							<tr key={project.id}>
								<td>
									<input
										type="checkbox"
										checked={selectedProjects.includes(
											project.id
										)}
										onChange={() =>
											onSelectProject(project.id)
										}
									/>
								</td>
								<td>{project.id}</td>
								<td>{project.clientId}</td>
								<td>{project.name}</td>
								<td>{project.clientName}</td>
								<td>{project.description}</td>
								<td>
									{Number(project.value).toLocaleString(
										'pt-BR',
										{
											style: 'currency',
											currency: 'BRL',
										}
									)}
								</td>
								<td>
									{project.due_date
										? new Date(
												project.due_date
										  ).toLocaleDateString('pt-BR')
										: '-'}
								</td>
								<td>
									<span
										className={`status-badge ${
											project.status === 'pending'
												? 'status-pending'
												: project.status ===
												  'in_progress'
												? 'status-in-progress'
												: 'status-completed'
										}`}
									>
										{project.status === 'pending'
											? 'PENDENTE'
											: project.status === 'in_progress'
											? 'EM ANDAMENTO'
											: 'CONCLUÍDO'}
									</span>
								</td>
								<td>
									<button
										className="edit"
										onClick={() => startEditing(project)}
									>
										Editar
									</button>
									<button
										className="delete"
										onClick={() =>
											deleteProject(project.id)
										}
									>
										Excluir
									</button>
								</td>
							</tr>
						))
					) : (
						<tr>
							<td colSpan="10" className="no-data">
								Nenhum projeto encontrado.
							</td>
						</tr>
					)}
				</tbody>
			</table>
		</div>
	);
};

export default ProjectsTable;
